module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-right-arrow-gray-light-on-white-c24584914b6cdf2e09de5b2f3c0c610b.svg";